import { useEffect, useMemo } from 'react';
import { LOGGED_IN_USER_KEY } from '../../config';

const ChangeMapDataprovider = ({ layerData, setSource }) => {
    const user = useMemo(() => JSON.parse(localStorage.getItem(LOGGED_IN_USER_KEY)), []);

    const { isLayerVisible, layerStringCode, layerStringDate } = layerData;

    useEffect(() => {
        if (isLayerVisible === false || layerStringCode === '' || layerStringDate === '') {
            setSource(null);
            return;
        }

        setSource({
            url: `/api/layers/wms/${layerStringCode}?token=${user.token}`,
            params: {
                LAYERS: 'georisk:changemap_mosaic',
                DATE: layerStringDate,
                MEPAR_CODE: layerStringCode,
                SRS: 'EPSG:23700',
            },
        });
    }, [isLayerVisible, layerStringCode, layerStringDate, user]);

    // this is a HOC
    return null;
};

export default ChangeMapDataprovider;
